module.exports = __webpack_public_path__ + "assets/6cc45d4f5828dce911d3b8a34862d5e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/1.png
// module id = 378
// module chunks = 1